module.exports = __webpack_public_path__ + "img/help.488d60bb.jpg";